export default "__VITE_ASSET__KSeQ3ZK2__"